import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { BentoHero as BentoHeroComponent } from '@thd-olt-component-react/hero';
import { arrayOf, bool, shape, string } from 'prop-types';

export function BentoHero({ id, renderDefault, variationIds = [] }) {
  return (
    <ErrorBoundary name="bento-hero">
      <QueryProvider cacheKey="bento-hero-cache" defaultVariables={{ isCarousel: false }}>
        <BentoHeroComponent
          componentClass="BentoHero"
          componentId={id}
          enableB2CRadius
          renderDefault={renderDefault}
          variationIds={variationIds}
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

BentoHero.propTypes = {
  id: string.isRequired,
  renderDefault: bool,
  variationIds: arrayOf(
    shape({})
  )
};

BentoHero.defaultProps = {
  renderDefault: false,
  variationIds: []
};
